
// Global Variables
const desktop = window.matchMedia("(min-width: 1300px)");
const tablet = window.matchMedia("(max-width: 991px)");
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

module.exports = { desktop, tablet, scrollElement }
